import {useCallback, useState} from 'react';

const initialState = {
    open: false,
    anchorEl: null,
    anchorPosition: null,
    data: null,
    nodePos: null,
    view: null,
};

export function useFloatingInteraction(dataMapper) {
    const [state, setState] = useState(initialState);

    const handleOpen = useCallback((payload) => {
        setState({
            open: true,
            anchorEl: payload?.anchorEl || null,
            anchorPosition: payload?.anchorPosition || null,
            data: dataMapper ? dataMapper(payload || {}) : (payload || null),
            nodePos: payload?.nodePos ?? null,
            view: payload?.view || null,
        });
    }, [dataMapper]);

    const handleClose = useCallback(() => {
        setState(initialState);
    }, []);

    return {
        open: state.open,
        anchorEl: state.anchorEl,
        anchorPosition: state.anchorPosition,
        data: state.data,
        nodePos: state.nodePos,
        view: state.view,
        handleOpen,
        handleClose,
    };
}

